<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">金幣獎勵設置</h1>
      </div>
    </div>

    <div class="layout">
      <!-- 统一风格搜索区 -->
      <div class="search-card">
        <div class="search-row">
          <el-input
              v-model="listQuery.ruleKey"
              placeholder="規則Key"
              prefix-icon="el-icon-search"
          ></el-input>

          <el-input
              v-model="listQuery.ruleName"
              placeholder="規則名稱"
              prefix-icon="el-icon-search"
          ></el-input>

          <div>
            <el-select v-model="listQuery.isEnable" clearable placeholder="是否啟用">
              <el-option label="啟用" :value="1"></el-option>
              <el-option label="停用" :value="0"></el-option>
            </el-select>
          </div>

          <div class="search-buttons">
            <el-button size="small" type="warning" @click="onSearch" icon="el-icon-search">搜尋</el-button>
            <el-button size="small" @click="onReset" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
      </div>

      <!-- 统一风格 PC表格 -->
      <div class="table-container">
        <el-table
            @sort-change="handleSortChange"
            :data="tableData"
            style="width:100%"
            border
            stripe
            size="small"
            :empty-text="tableData.length === 0 ? '暫無數據' : ''"
        >
          <el-table-column label="#" type="index" width="50" align="center"></el-table-column>
          <el-table-column prop="id" label="ID" align="center" sortable="custom" min-width="50"></el-table-column>
          <el-table-column prop="ruleKey" label="規則Key" align="center" sortable="custom" min-width="140"></el-table-column>
          <el-table-column prop="ruleName" label="規則名稱" align="center" sortable="custom" min-width="160"></el-table-column>
          <el-table-column prop="coins" label="獎勵金幣數" align="center" sortable="custom" min-width="100"></el-table-column>
          <el-table-column prop="description" label="規則說明" align="center" min-width="220"></el-table-column>
          <el-table-column label="狀態" align="center" min-width="90">
            <template slot-scope="{ row }">
              <el-tag :type="row.isEnable ? 'success' : 'danger'">
                {{ row.isEnable ? '啟用' : '停用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="建立時間" align="center" sortable="custom" min-width="160">
            <template slot-scope="{ row }">
              {{ row.updatedAt?.date?.split('.')[0] || '' }}
            </template>
          </el-table-column>

          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="onEditButton(scope.row)" icon="el-icon-edit">編輯</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <Pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery._page"
          :limit.sync="listQuery._limit"
          @pagination="getCoins"
      />
    </div>

    <!-- 编辑弹窗 -->
    <el-dialog
        title="編輯金幣獎勵規則"
        :visible.sync="editDialogVisible"
        width="600px"
        append-to-body
        close-on-click-modal
    >
      <el-form ref="editForm" :model="editForm" :rules="rules" label-width="100px" size="small">
        <el-form-item label="規則Key" prop="ruleKey">
          <el-input v-model="editForm.ruleKey" placeholder="不可重複"></el-input>
        </el-form-item>
        <el-form-item label="規則名稱" prop="ruleName">
          <el-input v-model="editForm.ruleName" placeholder="請輸入規則名稱"></el-input>
        </el-form-item>
        <el-form-item label="獎勵金幣" prop="coins">
          <el-input v-model.number="editForm.coins" type="number" min="0" placeholder="請輸入金幣數"></el-input>
        </el-form-item>
        <el-form-item label="規則說明" prop="description">
          <el-input v-model="editForm.description" type="textarea" rows="3" placeholder="請輸入規則說明"></el-input>
        </el-form-item>
        <el-form-item label="是否啟用" prop="isEnable">
          <el-radio-group v-model="editForm.isEnable">
            <el-radio :label="1">啟用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeEditDialog">取 消</el-button>
        <el-button type="primary" @click="submitEditForm">保 存 修 改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
// 使用你現有的 api
import {getCoins,putCoin} from "@/api/coin";

export default {
  components: { Pagination },
  data() {
    return {
      total: 0,
      editDialogVisible: false,
      currentId: null,
      listQuery: {
        ruleKey: null,
        ruleName: null,
        isEnable: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      editForm: {
        ruleKey: '',
        ruleName: '',
        coins: 0,
        description: '',
        isEnable: 1,
      },
      rules: {
        ruleKey: [{ required: true, message: '請輸入規則Key', trigger: 'blur' }],
        ruleName: [{ required: true, message: '請輸入規則名稱', trigger: 'blur' }],
        coins: [{ required: true, message: '請輸入獎勵金幣數', trigger: 'blur' }],
        isEnable: [{ required: true, message: '請選擇狀態', trigger: 'change' }],
      },
      tableData: [],
    };
  },
  created() {
    this.getCoins();
  },
  methods: {
    // 编辑
    onEditButton(row) {
      this.currentId = row.id;
      this.editForm = {
        ruleKey: row.ruleKey || '',
        ruleName: row.ruleName || '',
        coins: Number(row.coins) || 0,
        description: row.description || '',
        isEnable: row.isEnable,
      };
      this.editDialogVisible = true;
    },
    closeEditDialog() {
      this.editDialogVisible = false;
      this.currentId = null;
    },
    submitEditForm() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;
        putCoin(this.currentId, this.editForm).then(() => {
          this.$message.success('修改成功');
          this.closeEditDialog();
          this.getCoins();
        }).catch(() => {
          this.$message.error('修改失敗');
        });
      });
    },

    // 基础功能
    handleSortChange(col) {
      this.listQuery.orderBy = col.order ? `${col.prop} ${col.order === "descending" ? "desc" : "asc"}` : null;
      this.listQuery._page = 1;
      this.getCoins();
    },
    onSearch() {
      this.listQuery._page = 1;
      this.getCoins();
    },
    onReset() {
      Object.keys(this.listQuery).forEach(k => {
        this.listQuery[k] = null;
        if (k === "_page") this.listQuery[k] = 1;
        if (k === "_limit") this.listQuery[k] = 10;
      });
      this.getCoins();
    },
    getCoins() {
      const params = { ...this.listQuery, _page: this.listQuery._page - 1 };
      Object.keys(params).forEach(key => {
        if (params[key] == null) delete params[key];
      });
      getCoins(params).then(v => {
        this.tableData = v.data || [];
        this.total = +v.headers["x-total-count"] || 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;

  .page-title {
    font-size: 20px;
    font-weight: 600;
    color: #B62D2E;
    margin: 0;
  }
}

.layout {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;

    .el-input, .el-select {
      flex: 1;
      min-width: 160px;
    }

    .search-buttons {
      display: flex;
      gap: 8px;
    }
  }
}

.table-container {
  width: 100%;
}

.pagination-wrap {
  text-align: center;
  padding: 10px 0;
}

.dialog-footer {
  text-align: right;
}

@media (max-width: 768px) {
  .page { padding: 8px; }
  .layout { padding: 12px; }
  .search-row { flex-direction: column; align-items: stretch; }
}
</style>
